module.exports = __webpack_public_path__ + "static/productVariationImage-eb9996c5e8ca1de557526ff3127ec936.png";